module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3286e2838658ebdb82f62d062b14e951.svg";